import CalculateOutlinedIcon from "@mui/icons-material/CalculateOutlined";
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";
import type { SxProps, Theme } from "@mui/material";
import { ListItemIcon, ListItemText, Typography } from "@mui/material";
import PopoverMenuItem from "@entrilia/shared/components/PopoverMenuItem";

interface Props {
  onMouseEnter: (target: HTMLElement | null) => void;
  onMouseLeave: (target: EventTarget | null) => void;
  onClick: (target: HTMLElement) => void;
  sx?: SxProps<Theme>;
}
const CalculationMenuItem = ({ onMouseEnter, onMouseLeave, onClick, sx }: Props) => {
  return (
    <PopoverMenuItem
      onMouseEnter={(e) => {
        onMouseEnter(e.currentTarget);
        e.stopPropagation();
      }}
      onClick={(e) => {
        onClick(e.currentTarget);
        e.stopPropagation();
      }}
      onMouseLeave={(e) => {
        onMouseLeave(e.relatedTarget);
      }}
      sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", ...sx }}
    >
      <>
        <ListItemIcon>
          <CalculateOutlinedIcon />
        </ListItemIcon>
        <ListItemText>
          <Typography>Calculation</Typography>
        </ListItemText>
        <ChevronRightRoundedIcon color="action" />
      </>
    </PopoverMenuItem>
  );
};

export default CalculationMenuItem;
